<template lang='pug'>
  .expandable-content-wrapper
    .content-overlay(
      v-if='showOverlay()'
      :style='{ height: `${maxHeight}px` }'
    )
    .expandable-content(
      :class='{ "expanded": contentExpanded }'
      :style='{ maxHeight: `${maxHeight}px` }'
      v-html='content'
      ref='content'
    )
    a.content-action(
      href='#0'
      @click.prevent='toggleExpandContent'
      v-text='contextActionText'
      v-if='shouldShowContentAction'
    )
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      required: true
    },
    maxHeight: {
      type: Number,
      default: 50
    }
  },

  data () {
    return {
      contentExpanded: false,
      shouldShowContentAction: false
    }
  },

  computed: {
    contextActionText () {
      if (this.contentExpanded) {
        return this.$t('products.readLess')
      } else {
        return this.$t('products.readMore')
      }
    }
  },

  mounted () {
    this.handleWindowResize()
    window.addEventListener('resize', this.handleWindowResize)
  },

  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
  },

  methods: {
    toggleExpandContent () {
      this.contentExpanded = !this.contentExpanded
    },

    handleWindowResize () {
      this.$nextTick(function () {
        if (this.$refs.content.scrollHeight > this.maxHeight) {
          this.shouldShowContentAction = true
        } else {
          this.shouldShowContentAction = false
        }
      })
    },

    showOverlay () {
      return this.shouldShowContentAction && !this.contentExpanded
    }
  }
}
</script>
<style lang='scss' scoped>
  .expandable-content-wrapper {
    .expandable-content {
      overflow-y: hidden;

      &.expanded {
        max-height: initial !important;
      }
    }
    .content-action {
      display: block;
      text-align: right;
      text-decoration: underline;
      margin-right: 5px;
    }

    .content-overlay {
      position: absolute;
      width: 100%;
      background: linear-gradient(hsla(0,0%,100%,0), $white);
    }
  }
</style>
